// extracted by mini-css-extract-plugin
export default {"apis-heading":"ApisHeader_apis-heading__M28ea","apis-header":"ApisHeader_apis-header__SZvei","apis-header-home-page":"ApisHeader_apis-header-home-page__7d-YC"};